import apiClient from "api/api-client";
import { QUERY_KEYS } from "constants/query-keys";
import { useGetOne } from "hooks/use-get-one";
import { DevelopmentProgram, LearningProgram, PublicProgram } from "types/program";

export const usePublicProgram = (id: string) => {
  return useGetOne({
    keys: [QUERY_KEYS.program, id],
    queryFn: async () => {
      return apiClient.get<PublicProgram>(`/public/programs/${id}`);
    },
  });
};
